import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CoursesHeader from './components/CoursesHeader';
import CoursesList from './components/CoursesList';

const CoursesPage = () => {
  return (
    <>
      <title>Uygulamalı Kurslar | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 uygulamalı kursları. İmplantoloji, ortodonti, periodontoloji ve daha fazlası için hands-on eğitim fırsatları. 2-3 Mayıs 2026, İstanbul." />
      <meta name="keywords" content="istanbul dental kongresi kurslar, implantoloji kursu istanbul, ortodonti uygulamalı kurs, dental hands-on eğitim" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/kurslar" />
      <meta property="og:title" content="Uygulamalı Kurslar | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="İmplantoloji, ortodonti ve daha fazlası için uygulamalı kurs fırsatları. 2-3 Mayıs 2026, İstanbul." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/kurslar" />
      <div className="min-h-screen bg-white">
        <Navbar />
        <CoursesHeader />
        <CoursesList />
        <Footer />
      </div>
    </>
  );
};

export default CoursesPage;
